var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinIconsCrossFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.991 6.38163C7.15507 6.21777 7.37746 6.12573 7.60934 6.12573C7.84121 6.12573 8.06361 6.21777 8.22767 6.38163L22.2277 20.3816C22.3136 20.4617 22.3826 20.5583 22.4304 20.6657C22.4782 20.773 22.504 20.8889 22.506 21.0064C22.5081 21.1238 22.4865 21.2405 22.4425 21.3495C22.3985 21.4584 22.333 21.5574 22.2499 21.6405C22.1668 21.7236 22.0678 21.7891 21.9589 21.8331C21.8499 21.8771 21.7332 21.8987 21.6157 21.8967C21.4982 21.8946 21.3824 21.8689 21.275 21.821C21.1677 21.7732 21.0711 21.7043 20.991 21.6183L6.991 7.6183C6.82715 7.45423 6.73511 7.23184 6.73511 6.99996C6.73511 6.76809 6.82715 6.54569 6.991 6.38163Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2276 6.38163C22.3915 6.54569 22.4835 6.76809 22.4835 6.99996C22.4835 7.23184 22.3915 7.45423 22.2276 7.6183L8.22761 21.6183C8.06174 21.7729 7.84235 21.857 7.61567 21.853C7.38898 21.849 7.1727 21.7572 7.01238 21.5969C6.85207 21.4365 6.76024 21.2203 6.75624 20.9936C6.75224 20.7669 6.83638 20.5475 6.99094 20.3816L20.9909 6.38163C21.155 6.21777 21.3774 6.12573 21.6093 6.12573C21.8412 6.12573 22.0635 6.21777 22.2276 6.38163Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIconsCrossFilled);
export default __webpack_public_path__ + "static/media/bitcoin-icons_cross-filled.3f08d59c5e7c0ac4f02a15f68de2dc88.svg";
export { ForwardRef as ReactComponent };